import React from 'react'
import { BaseConfig } from '../BaseConfig';

import { UIProperties } from '../../cvp-webgames-core/Components/ui/UIProperties';

import "./alert-ui.css"

const OverlayImg = (props: UIProperties<OverlayImgConfig>) => {
	return (
		props.parameters.hide ? (null) : <div className="overlay-img-root modal-disable-select" style={{
			zIndex: 100
		}}>
			<img style={{
				width: '100%',
				height: '100%'
			}} src={props.parameters.imgSrc} alt="" />
		</div>
	);

};

export interface OverlayImgConfig extends BaseConfig {
	imgSrc?: string;
	hide?: boolean;
}

export default OverlayImg;